export const env = {
  BASE_URL: "https://conquestpoolsbackendmiddleware.azurewebsites.net/api"
}